export default __webpack_public_path__ + "static/media/855.5f2dbcbc.png";